<template>
  <div id="login-v2" class="auth-wrapper auth-v1">
    <div class="background" v-lazy:background-image="imgObj">
      <!-- Navigation -->
      <nav
        v-lazy:background-image="imgObjNav"
        class="navbar navbar-default navbar-fixed-top navbar-shrink"
      >
        <div class="d-flex justify-content-between">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header page-scroll">
            <ul class="nav navbar-nav d-xl-none">
              <li class="nav-item">
                <a href="#" target="_self" class="nav-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21px"
                    height="21px"
                    viewBox="0 0 24 24"
                    v-if="!isNavOpen"
                    @click="isNavOpen = !isNavOpen"
                    fill="none"
                    stroke="currentColor"     
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-menu"
                  >
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    height="20px"
                    @click="isNavOpen = !isNavOpen"
                    v-else
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="d-block d-xl-none feather feather-x"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </a>
              </li>
            </ul>

            <a href="/" class="logo nav-link"
              ><img v-lazy="urlLogo" alt=""
            /></a>
          </div>

          <!-- Collect the nav links, forms, and other content for toggling -->
          <div :class="[{ open: isNavOpen }, 'collapse']">
            <ul class="nav">
              <li class="">
                <a class="page-scroll" href="#services">{{ $t("home") }}</a>
              </li>
              <li class="">
                <a class="page-scroll" href="#portfolio">
                  {{ $t("aboutWR1") }}</a
                >
              </li>
              <li class="">
                <a class="page-scroll" href="#about"
                  >{{ $t("ourServices") }}
                </a>
              </li>
              <li class="">
                <a class="page-scroll" href="#team">{{ $t("wR1Platform") }} </a>
              </li>
              <li class="">
                <a class="page-scroll" href="#contact"
                  >{{ $t("marketsKnowledge") }}
                </a>
              </li>
              <li class="">
                <a class="page-scroll" href="#contact"
                  >{{ $t("logisticsSolutions") }}
                </a>
              </li>
              <li class="">
                <a class="page-scroll" href="#contact">{{ $t("news") }}</a>
              </li>
              <li class="">
                <a class="page-scroll" href="#contact">FAQ</a>
              </li>
              <li class="">
                <a class="page-scroll" href="#contact">{{ $t("contact") }}</a>
              </li>
              <li v-if="isNavOpen">
                <VueLocale></VueLocale>
              </li>
            </ul>
          </div>
          <div v-if="!isNavOpen" class="d-none d-xl-block">
            <VueLocale></VueLocale>
          </div>
          <!-- /.navbar-collapse -->
        </div>
        <!-- /.container-fluid -->
      </nav>
      <!-- Header -->
      <header>
        <div class="container-login">
          <div class="content-login">
            <Transition appear name="nested-left">
              <div
                v-show="show"
                @mouseleave="hideTimeOut"
                @mouseenter="myStopFunction"
                :class="[
                  'nav-bar child-div',
                  {
                    expand: isExpand,
                  },
                ]"
              >
                <ul class="top">
                  <li>
                    <img
                      class="icon-1"
                      v-lazy="
                        `${require('@/assets/images/icon-login/icon-1.png')}`
                      "
                      alt=""
                    />
                    <span>{{ $t("Home") }}</span>
                  </li>
                  <li>
                    <img
                      class="icon-2"
                      v-lazy="
                        `${require('@/assets/images/icon-login/icon-2.png')}`
                      "
                      alt=""
                    />
                    <span> {{ $t("quotation") }}</span>
                  </li>
                  <li>
                    <img
                      class="icon-1"
                      v-lazy="
                        `${require('@/assets/images/icon-login/icon-3.png')}`
                      "
                      alt=""
                    />
                    <span> {{ $t("Booking") }}</span>
                  </li>

                  <li>
                    <img
                      class="icon-1"
                      v-lazy="
                        `${require('@/assets/images/icon-login/icon-4.png')}`
                      "
                      alt=""
                    />
                    <span> {{ $t("Schedule") }}</span>
                  </li>
                  <li>
                    <img
                      class="icon-1"
                      v-lazy="
                        `${require('@/assets/images/icon-login/icon-5.png')}`
                      "
                      alt=""
                    />
                    <span> {{ $t("TrackTrace") }}</span>
                  </li>
                </ul>
                <ul class="bottom">
                  <li
                    @click="
                      () => {
                        isExpand = !isExpand;
                      }
                    "
                    :class="[' icon-3 over flex-center', { out: isExpand }]"
                  >
                    <img
                      v-lazy="
                        `${require('@/assets/images/icons/new-icon/Arrow.png')}`
                      "
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </Transition>
            <Transition appear name="nested">
              <div class="form-login child-div" v-show="show">
                <transition name="slide-fade">
                  <div
                    v-show="isError"
                    class="text-center error bg-error py-1 rounded-pill px-1"
                  >
                    <p class="text-light m-0 h6 font-weight-normal">
                      {{ $t(`${errMsg}`) }}
                    </p>
                  </div>
                </transition>

                <div class="form-login_box">
                  <h3
                    class="form-login_box__title"
                    :style="{ fontSize: $i18n.locale == 'vn' ? '2.3rem' : '' }"
                  >
                    {{ $t("welcomeTo") }} <span> WR1</span>
                  </h3>
                  <div class="form-login_box__tabs" card>
                    <div
                      @click="isLogin = true"
                      :class="['description_tab', 'active cursor-pointer']"
                    >
                      {{ $t("login") }}
                    </div>
                    <div class="cursor-pointer not-allowed" style="opacity: 0.5; pointer-events: none;">
                      {{ $t("register") }}
                    </div>

                    <span :class="[{ notActive: !isLogin }, 'hr-line ']"></span>
                  </div>
                  <div v-if="isLogin" class="loginForm">
                    <validation-observer ref="loginForm">
                      <b-form
                        class="auth-login-form mt-2"
                        @submit.prevent="login"
                      >
                        <b-form-group label-for="email" class="mt-2">
                          <div class="d-flex justify-content-between">
                            <label class="text-wr1 pl-2" for="password">
                              {{ $t("username") }}*</label
                            >
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('username')"
                            rules="required"
                          >
                            <b-form-input
                              id="email"
                              v-model="userEmail"
                              class="rounded-pill font-15"
                              name="login-email"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('enterUsername')"
                              autofocus
                            />
                            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                          </validation-provider>
                        </b-form-group>

                        <b-form-group class="mt-2">
                          <div class="d-flex justify-content-between">
                            <label class="text-wr1 pl-2" for="password">
                              {{ $t("password") }}*</label
                            >
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('password')"
                            rules="required"
                          >
                            <b-input-group
                              class="input-group-merge rounded-pill"
                              :class="errors.length > 0 ? 'is-invalid' : null"
                            >
                              <b-form-input
                                id="password"
                                v-model="password"
                                :type="passwordFieldType"
                                class="form-control-merge rounded-left-pill font-15"
                                :state="errors.length > 0 ? false : null"
                                name="login-password"
                                :placeholder="$t('enterPassword')"
                              />

                              <b-input-group-append
                                is-text
                                class="rounded-right-pill"
                              >
                                <component
                                  :key="passwordToggleIcon"
                                  @click="togglePasswordVisibility"
                                  :is="passwordToggleIcon"
                                />
                                <!-- 
                                <feather-icon
                                  class="cursor-pointer text-wr1"
                                  :icon="passwordToggleIcon"
                                /> -->
                              </b-input-group-append>
                            </b-input-group>
                            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                          </validation-provider>
                          <b-link
                            class="text-right text-wr1 d-block forgot-password-link"
                            :to="{ name: 'auth-forgot-password' }"
                          >
                            <small>{{ $t("forgotPassword") }}</small>
                          </b-link>
                        </b-form-group>

                        <!-- <b-form-group>
                      <span class="text-danger">{{ errMsg }}</span>
                    </b-form-group> -->

                        <b-button
                          variant="primary"
                          type="submit"
                          block
                          class="rounded-pill"
                        >
                          <h4 class="m-0 text-light">{{ $t("login") }}</h4>
                        </b-button>
                      </b-form>
                    </validation-observer>
                  </div>
                  <div style="color: #2b938c; font-weight: 700" v-else>
                    <validation-observer ref="registerForm">
                      <div class="auth-login-form mt-2 align-left">
                        <!-- email -->
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Email"
                            rules="required|email"
                          >
                            <label class="label">
                              {{ $t("email") }}<span>*</span> (eg.:
                              joe@xyz.com)</label
                            >
                            <b-form-input
                              v-model="user.email"
                              class="round"
                              autofocus
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('enterEmail')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>
                        <!-- email -->
                        <!-- email -->
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Company name"
                            rules="required"
                          >
                            <label class="label">
                              {{ $t("companyName") }}<span>*</span>
                            </label>

                            <b-form-input
                              v-model="user.companyName"
                              class="round"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('enterCompanyName')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>
                        <!-- email -->
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Contact name"
                            rules="required"
                          >
                            <label class="label"
                              >{{ $t("contactName") }}<span>*</span></label
                            >
                            <b-form-input
                              v-model="user.fullName"
                              class="round"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('placeholderName')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>
                        <!-- email -->
                        <!-- email -->
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Tax Code"
                            rules="required"
                          >
                            <label class="label">
                              {{ $t("taxCode") }}<span>*</span></label
                            >
                            <b-form-input
                              v-model="user.taxCode"
                              class="round"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('enterTaxCode')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Address"
                            rules=""
                          >
                            <label class="label"> {{ $t("address") }}</label>
                            <b-form-input
                              v-model="user.companyAddress"
                              class="round"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('enterAddress')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>

                        <label v-show="false" class="label">
                          {{ $t("gender") }}</label
                        >
                        <b-form-group class="pt-1" v-show="false">
                          <b-row>
                            <b-col cols="4">
                              <b-form-radio
                                v-model="user.genderId"
                                name="some-radios"
                                value="1"
                              >
                                {{ $t("Male") }}
                              </b-form-radio>
                            </b-col>
                            <b-col cols="4">
                              <b-form-radio
                                v-model="user.genderId"
                                name="some-radios"
                                value="2"
                              >
                                {{ $t("Female") }}
                              </b-form-radio>
                            </b-col>
                          </b-row>
                        </b-form-group>
                        <!-- email -->
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="Phone"
                            rules="regex:^([0-9]+)$"
                          >
                            <label class="label">
                              {{ $t("phone") }} (Only Phone)</label
                            >
                            <b-form-input
                              v-model="user.phone"
                              class="round"
                              :state="errors.length > 0 ? false : null"
                              :placeholder="$t('placeholderPhone')"
                            />
                            <small
                              v-show="errors.length > 0"
                              class="text-danger"
                              >{{ errors[0] }}</small
                            >
                          </validation-provider>
                        </b-form-group>
                        <b-button
                          variant="primary"
                          type="button"
                          @click="register"
                          block
                          class="rounded-pill mt-4"
                        >
                          <h4 class="m-0 text-light">{{ $t("register") }}</h4>
                        </b-button>
                      </div>
                    </validation-observer>
                  </div>
                </div>
              </div>
            </Transition>
            <Transition appear name="nested-right">
              <div v-show="show" class="intro-text">
                <div class="intro-lead-in">WR1 - As e-carrier,</div>
                <div class="intro-heading">We bring logistics online</div>
                <div class="row mx-0">
                  <div
                    class="col-12 p-0 col-lg-4 d-flex justify-content-start align-items-start"
                  >
                    <div class="icon-1">
                      <img
                        v-lazy="
                          `${require('@/assets/images/icon-login/icon-3-white.png')}`
                        "
                        alt=""
                      />
                    </div>
                    <div class="info ml-lg-1">
                      <p class="title">
                        {{ $t("myQuotation") }}
                      </p>
                      <p class="about">
                        {{ $t("myQuotationInfo") }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="col-12 col-lg-4 p-0 d-flex justify-content-start align-items-start"
                  >
                    <div class="icon-2">
                      <img
                        v-lazy="
                          `${require('@/assets/images/icon-login/icon-2-white.png')}`
                        "
                        alt=""
                      />
                    </div>
                    <div class="info ml-lg-1">
                      <p class="title">Booking</p>
                      <p class="about">
                        {{ $t("bookingInfo") }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="col-12 p-0 col-lg-4 d-flex justify-content-start align-items-start"
                  >
                    <div class="icon-2">
                      <img
                        v-lazy="
                          `${require('@/assets/images/icon-login/icon-5-white.png')}`
                        "
                        alt=""
                      />
                    </div>
                    <div class="info ml-lg-1">
                      <p class="title">{{ $t("TrackAndTrace") }}</p>
                      <p class="about">
                        {{ $t("TrackAndTraceInfo") }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="link-here">
                  <p class="m-0">
                    {{ $t("learnMore") }}, <a ref="#"> {{ $t("clickHere") }}</a>
                  </p>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </header>

      <footer class="footer-fixed-bottom">
        <div>
          <div class="row m-0">
            <div class="col-sm-6 footer-left pl-2">
              <p class="m-0 d-inline">
                <img
                  class="icon-phone"
                  v-lazy="`${require('@/assets/images/icon-login/phone.png')}`"
                  alt=""
                />
                +84 328 791 971
              </p>
              <p class="m-0 d-inline pl-3">
                <img
                  class="icon-mail"
                  v-lazy="`${require('@/assets/images/icon-login/email.png')}`"
                  alt=""
                />
                info@wr1.com.vn
              </p>
            </div>
            <div class="col-sm-6 footer-right text-right">
              <p class="m-0 d-inline pr-2">
                Copyright © 2023 Corporation. All rights reserved
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import VueLocale from "@core/layouts/components/app-navbar/components/LocaleSmall.vue";

import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import useJwt from "@/auth/jwt/useJwt";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import EyeShow from "@/assets/images/icons/file-icons/Hiện.svg?external";
import EyeHide from "@/assets/images/icons/file-icons/Ẩn.svg?external";

export default {
  components: {
    EyeShow,
    EyeHide,
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    VueLocale,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: {},
      myTimeout: null,
      isExpand: false,
      isNavOpen: false,
      show: false,
      appLogoImage: require("@/assets/images/logo/logo.png"),
      userEmail: "",
      password: "",
      status: "",
      // validation rules
      errMsg: "",
      isError: false,

      isLogin: true,
      imgObj: {
        src: require("@/assets/images/icon-login/bg-login.png"),
      },
      imgObjNav: {
        src: require("@/assets/images/icons/new-icon/bg-header.png"),
      },
      urlLogo: require("@/assets/images/logo/logo-login.png"),
      // :style="{
      //     backgroundImage: `url(${require('@/assets/images/icon-login/bg-login.jpg')})`,
      //   }"
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeHide" : "EyeShow";
    },
  },
  mounted() {
    this.show = true;
  },
  methods: {
    track () {
      this.$gtag.pageview('Login')
    },
    hideTimeOut() {
      this.myTimeout = setTimeout(() => {
        this.isExpand = false;
      }, 1000);
    },
    myStopFunction() {
      clearTimeout(this.myTimeout);
    },
    handler(component) {
    },
    register() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          useJwt
            .post("userListNoLogin", {
              registerInfo: JSON.stringify({ ...this.user }),
              ...this.user,
            })
            .then((response) => {
              if (
                response.data.result == "emailExists" ||
                response.data.result == "0"
              ) {
                return this.$swal({
                  icon: "warning",
                  html: `Email already exists. If you forgot your password <a href='/auth/forgot-password'>Click here</a>`,
                  focusConfirm: false,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }

         
              this.$swal({
                icon: "success",
                title: "Register success",
                text: "WR1 team is processing customer information. Please follow email or contact WR1 team directly with hotline (+84) 964 671 674!",
              });
              this.user = {};
              this.isLogin = true;
            })
            .catch((error) => {
              this.errMsg = error.message;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
    async login() {
      var vm = this;
      this.$gtag.event('login', { method: 'Google' })
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          this.$loading.show();
          useJwt
            .login({
              username: this.userEmail,
              password: this.password,
            })
            .then(async (response) => {
              const userData = response.data.result;
              useJwt.setToken(response.data.result.apiKey);
              localStorage.setItem("userData", JSON.stringify(userData));
              this.$ability.update(userData.ability);
              const menu = await this.$store.dispatch("masterData/fetchMenu");

              if (userData.requestedPasswordReset == 1) {
                this.$store.commit("appConfig/CHANGE_PASS", true);
              }
              if (menu.length == 0) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: `Account`,
                    icon: "XIcon",
                    variant: "danger",

                    text: `You do not have a permission to log in. if you think this is incorrect please contact your Wr1 administrators!`,
                  },
                });
              }
              this.$router
                .replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: `Welcome ${
                        userData.fullName || userData.username
                      }`,
                      icon: "CheckIcon",
                      variant: "success",
                      text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  });
                window.location.reload(true);
                });
            })
            .catch((error) => {
              this.$loading.hide();
              vm.isError = true;

              if (!error.response) {
                // network error
                vm.errMsg = "Network Error";
              } else {
                this.errMsg = vm.errMsg = "Sign in failed";
              }
              setTimeout(() => {
                this.isError = false;
              }, 5000);
            })
            .finally(() => {
              this.$loading.hide();
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/loginv2.scss";
</style>
<style scoped>
span.text-body {
  display: none;
}
li {
  list-style: none;
}
</style>
<style>
.nested-enter-active {
  transition: all 0.5s ease;
}
.nested-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.nested-enter, .nested-leave-to
/* Trước 2.1.8 thì dùng .nested-fade-leave-active */ {
  transform: translateY(-500px);
  opacity: 0;
}
.nested-left-enter-active {
  transition: all 0.3s ease;
}
.nested-left-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.nested-left-enter, .nested-left-leave-to
/* Trước 2.1.8 thì dùng .nested-fade-leave-active */ {
  transform: translateX(-50px);
  opacity: 0;
}

.nested-right-enter-active {
  transition: all 0.7s ease;
}
.nested-right-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.nested-right-enter, .nested-right-leave-to
/* Trước 2.1.8 thì dùng .nested-fade-leave-active */ {
  transform: translateX(500px);
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(0px);
  opacity: 0;
}

.label {
  font-size: 13px !important;
  font-weight: 500;
  color: #2b938c;
  margin-bottom: 0px;
  padding-left: 1.5rem !important;
}
.auth-login-form {
  text-align: left;
  height: 290px;
  overflow: auto;
  @media (min-height: 690px) {
    height: 290px;
    overflow: auto;
  }
  @media (min-height: 700px) {
    height: 390px;
    overflow: auto;
  }
  @media (min-height: 800px) {
    height: 500px;
    overflow: auto;
  }
  @media (min-height: 900px) {
    height: 525px;
    overflow: auto;
  }

  @media (min-height: 2000px) {
    height: 505px;
    overflow: auto;
  }
}

.auth-login-form::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.auth-login-form::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.auth-login-form::-webkit-scrollbar-thumb {
  background-color: #2b938cf8;
}
</style>
